import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMan = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 30" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#4D4D4D"
      transform="translate(1 1)"
    >
      <path
        strokeLinejoin="round"
        d="M5.801 6.417h1.373c1.885 0 2.87 1.115 2.819 3.598-.034 1.656.157 4.217.575 7.684.396 1.032.099 1.548-.892 1.548-.99 0-1.448-.379-1.372-1.137v-7.158 15.605c.366.96.085 1.44-.84 1.443-1.04 0-1.526-.398-1.459-1.193l-.1-10.21c0-.479-.11-.711-.517-.711-.406 0-.555.232-.555.712l-.1 10.21c.066.794-.42 1.192-1.46 1.192-.925-.003-1.205-.484-.84-1.443V10.952v7.158c.076.758-.382 1.137-1.372 1.137-.99 0-1.287-.516-.891-1.548.417-3.467.609-6.028.574-7.684-.051-2.483.934-3.598 2.82-3.598H5.8z"
      />
      <ellipse cx={5.148} cy={2.625} rx={2.725} ry={2.625} />
    </g>
  </svg>
);
const Memo = memo(SvgMan);
export default Memo;
